import delay from "lodash/delay";

let allSteps = document.querySelectorAll(".js-step-dot");
const stepsSVGElement = document.querySelector("#visual-steps-progress");
/* const SVG_WIDTH = 12; */ // Fixed width that should be set for the SVG
/* const X_AXIS_POS = 6; */ // Position of the steps, on the X axis, which is the same one for all the steps. It's half of the width of the SVG_WIDTH constant
/* const KEEP_CIRCLES_VISIBLE = 12; */ // Value to be used for keeping the start/end circles visible in the SVG
const COLORS = {
    RED: "#eb0203",
    WHITE: "#fff"
};

/**
 * Gets the current active step in the checkout process
 * @returns {number} - The current active index
 */
const getActiveIndex = () => Array.from(allSteps).findIndex(step => step.classList.contains("js-step-active"));

/**
 * Get filled steps indexes
 * @returns {array} filledIndexes - Array that contains the indexes of filled steps
 */
const getFilledIndexes = () => {
    const filledIndexes = [];

    Array.from(allSteps).forEach((step, index) => {
        if (step.classList.contains("js-step-filled")) {
            filledIndexes.push(index);
        }
    });

    return filledIndexes;
};

/**
 * Gets all the steps of the checkout
 * @returns {array} - A multidimensional array that contains the position of each step, on both axes
 */
/* const getStepsLocations = () => {
    const firstStepTop = $(allSteps[0]).offset().top;
    const stepsLocations = [];

    allSteps.forEach(step => {
        stepsLocations.push([X_AXIS_POS, $(step).offset().top - firstStepTop + KEEP_CIRCLES_VISIBLE]);
    });

    return stepsLocations;
}; */

/**
 * Remove all the targeted groups in order to create new ones afterwards
 * @param {string} dataAttrString - data attribute that is present for the groups that neede to be removeed
 */
const removeTargetedGroups = dataAttrString => {
    stepsSVGElement.querySelectorAll("g").forEach(g => {
        if (g.dataset.group === dataAttrString) {
            g.remove();
        }
    });
};

/**
 * Created the circles for each step and then they are included in the SVG at the positions
 * @param {array} stepsLocations - Contains the locations for each step
 * @param {element} SVGElem - The SVG element
 */
const generateCircles = (stepsLocations, SVGElem) => {
    removeTargetedGroups("g-circles");

    const circles = [];
    const circlesGroup = SVGElem.group();
    const filledStepsIndexes = getFilledIndexes();

    // Create the circle elements
    stepsLocations.forEach(elem => circles.push(SVGElem.circle(elem[0], elem[1], 4.5)));
    // Add style for each circle
    circles.forEach((circle, idx) => {
        // Check if step is filled and set the specific circle type
        if (filledStepsIndexes.includes(idx)) {
            circle.attr({ fill: COLORS.RED });
        } else {
            circle.attr({ fill: COLORS.WHITE, stroke: COLORS.RED, strokeWidth: 1 });
        }
    });
    // Insert the circle elements inside a group
    circlesGroup.add(circles);
    circlesGroup.attr("data-group", "g-circles");
};

/**
 * Created the dashed lines between the circles
 * @param {array} stepsLocations - Contains the locations for each step
 * @param {element} SVGElem - The SVG element
 */
const generateDashedLines = (stepsLocations, SVGElem) => {
    removeTargetedGroups("g-dash-lines");

    const dashLines = [];
    const dashLinesGroup = SVGElem.group();
    // Create the line elements
    stepsLocations.forEach((elem, idx) => {
        const nextLine = stepsLocations[idx + 1];
        if (nextLine === undefined) { return; }
        dashLines.push(SVGElem.line(elem[0], elem[1], nextLine[0], nextLine[1]));
    });
    // Add style for each line
    dashLines.forEach(line => line.attr({stroke: COLORS.RED, strokeWidth: 2, strokeDasharray: "6 2"}));
    dashLinesGroup.add(dashLines);
    dashLinesGroup.attr("data-group", "g-dash-lines");
};

/**
 * Created the lines between the circles
 * @param {array} stepsLocations - Contains the locations for each step
 * @param {element} SVGElem - The SVG element
 */
const generateLines = (stepsLocations, SVGElem) => {
    removeTargetedGroups("g-full-lines");

    // Lines creation
    const lines = [];
    const fullLinesGroup = SVGElem.group();
    // Create the line elements
    stepsLocations.forEach((elem, idx) => {
        const nextLine = stepsLocations[idx + 1];
        // Check what is the index where we need to stop the full line, based on the current active step
        if (idx + 1 > getActiveIndex()) { return; }
        if (nextLine === undefined) { return; }

        lines.push(SVGElem.line(elem[0], elem[1], nextLine[0], nextLine[1]));
    });
    // Add style for each line
    lines.forEach(line => line.attr({stroke: COLORS.RED, strokeWidth: 2 }));
    fullLinesGroup.add(lines);
    fullLinesGroup.attr("data-group", "g-full-lines");
};

/**
 * Initialize the visual steps creation
 */
const initVisualSteps = () => {
    //We need to reiterate the allSteps now, because we can have some updates on the page when initVisualSteps is called
    //This happens because on page load, some steps are hidden by d-none
/*     allSteps = document.querySelectorAll(".main-section--wrapper:not(.d-none) .js-step-dot");
    const stepsLocations = getStepsLocations();
    const distanceToStartSVG = $(allSteps[0]).offset().top - document.querySelector(".header").offsetHeight - document.querySelector(".checkout-page-title--wrapper").offsetHeight;
    stepsSVGElement.style.marginTop = `${distanceToStartSVG}px`;
    stepsSVGElement.setAttribute("height", parseInt(stepsLocations[stepsLocations.length - 1][1], 10) + KEEP_CIRCLES_VISIBLE);
    stepsSVGElement.setAttribute("width", SVG_WIDTH); */
};

/**
 * Initialize the visual steps creation with delay
 */
const initVisualStepsDelayed = (delaytime = 150) => {
    delay(initVisualSteps, delaytime);
};

/**
 * Clears the contents of the SVG and then reinitializes the visual steps with a slight delay in order to wait for page re-render
 * @param {number} delaytime - Delay time until the reinit should be done. Set 100 as default
 */
const reInitVisualSteps = (delaytime = 100) => {
    delay(initVisualSteps, delaytime);
};

export {
    initVisualStepsDelayed,
    reInitVisualSteps,
    generateCircles,
    generateDashedLines,
    generateLines
};
